module.exports = __webpack_public_path__ + "img/subject4_08.jpg";